import { IconSvg } from './IconSvg'
import type { IconProps } from './IconSvg'

/** capsule pill. Decorative line icon; always pair with a visible text label. */
export function PillIcon({ size, className }: IconProps) {
  return (
    <IconSvg size={size} className={className}>
      <path d="M10.3 20.7a4.9 4.9 0 0 1-7-6.9l7-7a4.9 4.9 0 0 1 6.9 7l-7 6.9z" />
      <path d="M8.7 8.7l6.6 6.6" />
    </IconSvg>
  )
}
